import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-athlete-rank',
  templateUrl: './athlete-rank.component.html',
  styleUrls: ['./athlete-rank.component.scss']
})
export class AthleteRankComponent implements OnInit {

  /**
   * An input property to show the variation with + i or = with a css class. Default to true, set to false for hide
   *
   * @type {boolean}
   * @memberof AthleteRankComponent
   */
  @Input()
  showVariation: boolean = true;
  @Input()
  rank: number;
  @Input()
  rankPrevious: number;
  value = { rank: undefined, rankOld: undefined }

  /**
   * An input for check if the athlete is new.
   *
   * @type {boolean}
   * @memberof AthleteRankComponent
   */
  @Input()
  isNew: boolean;
  constructor() { }

  ngOnInit() {
    if (this.rank == undefined) {
      throw new Error("property rank id it's not defined please bind property <lib-athlete-rank [rank]='your-data'")
    }
    if (this.rankPrevious == undefined && this.isNew == undefined) {
      throw new Error("property rankPrevious id and is new is not defined it's not defined please bind property <lib-athlete-rank [rankPrevious]='your-data'")
    }
    this.value.rank = this.rank;
    this.value.rankOld = this.rankPrevious;
  }

}
